import { GetHistoryRequest } from '@weave/schema-gen-ts/dist/schemas/comm/history/v1/history_service.pb';
import { SchemaCommHistoryService } from '@frontend/schema';

export const getPersonHistory = async ({
  personId,
  locationId,
  groupIds,
  limit,
  skip,
  includeCallIntelligence = false,
}: GetHistoryRequest) => {
  return SchemaCommHistoryService.GetHistory({
    personId,
    locationId,
    limit,
    groupIds,
    skip,
    includeCallIntelligence,
  });
};
